import { getYear } from 'date-fns';
import getMaxYear from './getMaxYear';

/**
 * Returns true if the provided car can be considered as "new" for the registered year
 *
 * @param carYear - The year registered for the current car
 */
export default function isNewCarForYear(carYear: number): boolean {
  const currentYear = getYear(new Date());
  return carYear >= currentYear - 1 && carYear <= getMaxYear();
}
